import { useEffect, useState } from 'react';
import { MinusIcon, PlusIcon } from './Icons';
import { Modal } from './Modal';

interface Props {
  open: boolean;
  dishName: string;
  value: number;
  onClose: () => void;
  onApply: (value: number) => void;
}

export function BatchAdjustModal({ open, dishName, value, onClose, onApply }: Props) {
  const [draft, setDraft] = useState(value);

  useEffect(() => {
    if (open) setDraft(value);
  }, [open, value]);

  const update = (next: number) => setDraft(Math.min(99, Math.max(1, Math.round(next))));

  return (
    <Modal open={open} title="调整用量" eyebrow={dishName} onClose={onClose}>
      <div className="batch-editor">
        <p>每批按 50 人固定配方计算</p>
        <div className="batch-editor__stepper" aria-label={`${dishName}批次数量`}>
          <button type="button" disabled={draft <= 1} onClick={() => update(draft - 1)} aria-label={`减少${dishName}一批`}><MinusIcon size={22} /></button>
          <span><strong>{draft}</strong><small>批</small></span>
          <button type="button" disabled={draft >= 99} onClick={() => update(draft + 1)} aria-label={`增加${dishName}一批`}><PlusIcon size={22} /></button>
        </div>
        <p className="batch-editor__people">预计按 {draft * 50} 人用量计算</p>
        <button className="button button--primary" type="button" onClick={() => { onApply(draft); onClose(); }}>完成调整</button>
      </div>
    </Modal>
  );
}
